export const CATEGORIES = ['전체', '디버깅', '클린코드', '아키텍처'];
export const SKILLS = ['React', 'Javascript', 'Typescript', 'Next.js', 'React Native'];
